module.exports = __webpack_public_path__ + "6562a12251b11dcedd8a721bb7b4e715.jpg";